import {
  Page,
  Navbar,
  NavTitle,
  Block,
  f7,
} from 'framework7-react';
import { BottomTabBar } from './BottomTabBar';
import '@styles/supportPage.css';
import { getCurrentUser, getDocument, addDocument } from '../firebase';


import PhoneIcon from '@assets/icons/ic_call.svg?react';
import SentIcon from '@assets/icons/sent.svg';
import LawyersImage from '@assets/lawyers.png';

function SupportPage() {
  const handleCall = async () => {
    const user = await getCurrentUser()
    if (!user) return

    f7.dialog.preloader('Sending Request...')

    let name = user.displayName || user.email?.split('@')[0] || 'User'
    let phoneNumber = user.phoneNumber || 'Unknown'
    let userEmail = user.email || ''

    const cached = localStorage.getItem('userInfo')
    if (cached) {
      try {
        const info = JSON.parse(cached) as {
          fullName?: string
          phoneNumber?: string
          email?: string
        }
        name = info.fullName || name
        phoneNumber = info.phoneNumber || phoneNumber
        userEmail = info.email || userEmail
      } catch { }
    }

    try {
      const snap = await getDocument(`users/${user.uid}`)
      if (snap.exists()) {
        const data = snap.data() as {
          fullName?: string
          email?: string
          phoneNumber?: string
        }
        if (data.fullName) name = data.fullName
        if (data.phoneNumber) phoneNumber = data.phoneNumber
        if (data.email) userEmail = data.email
        localStorage.setItem('userInfo', JSON.stringify(data))
      }
    } catch (err) {
      console.error('Error fetching user info', err)
      try {
        // getDocFromCache not available on native plugin
      } catch (cacheErr) {
        console.error('Cache fetch failed', cacheErr)
      }
    }

    console.log('User info', { name, phoneNumber, email: userEmail })

    try {
      await addDocument('helpRequests', {
        name,
        phoneNumber,
        createdAt: Date.now(),
        ...(userEmail ? { email: userEmail } : {}),
      });

      f7.dialog.close()

      f7.dialog.create({
        cssClass: 'support-success-dialog',
        title: `
        <style>
          .support-success-dialog .dialog {
            width: 320px !important;
            max-width: 120vw !important;
            padding: 24px 16px;
            border-radius: 16px;
          }
            
          .support-success-dialog .dialog-inner {
            padding: 0 !important;
          }

          .support-success-dialog .dialog-inner:after {
            background-color: transparent !important;
            display: none !important;
          }

          .support-success-dialog .dialog-title {
            margin-bottom: 12px;
          }
          .support-success-dialog .dialog-buttons {
            margin: 10px 10px;
            padding: 0;
            
          }
          .support-success-dialog .dialog-button {
            border-radius: 13px !important;
            background-color: #333D54;
            color: #4BAEF5;
            width: 100%;
            font-weight: 600;
          }
        </style>

          <div style="text-align: center; margin-top: 12px;">
            <img src="${SentIcon}" alt="sent icon" width="28" height="28" />
          </div>
        <div style="
          font-family: 'Merriweather', serif;
          font-size: 22px;
          font-weight: 700;
          color: #000000;
          margin-top: 10px;
          text-align: center;
        ">
          Message sent
        </div>
      `,
        text: `
        <div style="
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          color: #000000;
          line-height: 1.5;
          text-align: center;
          padding: 0 16px;
          margin-bottom: 15px;
        ">
          Thank you. We’ve received your request. A lawyer will contact you within 1 hour using the contact information we have on file.
        </div>
      `,
        buttons: [
          {
            text: 'Got it',
            cssClass: 'dialog-button-highlight bold-button',
          },
        ],
        verticalButtons: false,
      }).open();
    } catch (err) {
      f7.dialog.close();
      console.error('API call failed', err);
      f7.toast
        .create({
          text: 'Error. Call was not made. Try again',
          closeTimeout: 3000,
          position: 'top',
          cssClass: 'error-toast',
        })
        .open();
    }
  };

  const openEmailForm = async () => {
    const user = await getCurrentUser()
    let name = user?.displayName || user?.email?.split('@')[0] || 'User'
    let phoneNumber = user?.phoneNumber || 'Unknown'
    let userEmail = user?.email || 'unknown@example.com'

    const cached = localStorage.getItem('userInfo')
    if (cached) {
      try {
        const info = JSON.parse(cached) as {
          fullName?: string
          phoneNumber?: string
          email?: string
        }
        name = info.fullName || name
        phoneNumber = info.phoneNumber || phoneNumber
        userEmail = info.email || userEmail
      } catch { }
    }

    const subject = 'TBD'
    const body = encodeURIComponent(
      `Name: ${name}\nPhone: ${phoneNumber}\nEmail: ${userEmail}`
    )

    window.location.href =
      'mailto:dealsaver@legalclosing.ca' +
      '?subject=' +
      encodeURIComponent(subject) +
      '&body=' +
      body
  }

  return (
    <Page name="support" className="support-page">
      <Navbar className="no-outline">
        <NavTitle>Support</NavTitle>
      </Navbar>

      <Block className="support-block">
        <div className="support-card">
          <div className="lawyer-group-image">
            <img
              src={LawyersImage}
              alt="Lawyers"
              className="lawyer-composite"
            />
          </div>

          <h2>Connect with a lawyer</h2>

          <p style={{ marginTop: '11px' }}>
            Need legal help? Tap below and a lawyer will call you back within 1 hour, available from 11:00 AM to 8:00 PM.
          </p>


          <div className="phone-icon-button" onClick={handleCall}>
            <PhoneIcon />
          </div>
        </div>

        <div className="support-contact-note">
          If you prefer, you can also <br />
          <a onClick={openEmailForm}>email us instead contact</a>
        </div>
      </Block>

      <BottomTabBar />
    </Page>
  );
}

export default SupportPage;
